var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B4F63",
    d: "M12 1c2.761 0 5 2.239 5 5v3h1c1.105 0 2 .895 2 2v10c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V11c0-1.105.895-2 2-2h9V6c0-1.657-1.343-3-3-3-1.598 0-2.904 1.249-2.995 2.824L9 6c0 .552-.448 1-1 1s-1-.448-1-1c0-2.761 2.239-5 5-5zm6 10H6v10h12V11zm-6 3c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.9adeb6838ffa7a79a7fb966cfe18542c.svg";
export { ForwardRef as ReactComponent };